import {CandidatStatusOnMission} from '../enums';

export const StrongPasswordRegx: RegExp =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*/])[A-Za-z\d!@#$%^&*/]{8,}$/;

export const candidatAccepted: CandidatStatusOnMission[] = [
  CandidatStatusOnMission.ACCEPTED,
  CandidatStatusOnMission.CONTRACT_PENDING_VALIDATION,
  CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH,
  CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT,
  CandidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT,
  CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION,
  CandidatStatusOnMission.PAYMENT_DONE,
  CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY,
];

export const candidateApplied: CandidatStatusOnMission[] = [
  CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION,
  CandidatStatusOnMission.REJECTED
];

/**
 * French label shown in the UI for each CandidatStatusOnMission value.
 * Used by mission-candidatures cards to display the real candidate status
 * instead of a hardcoded "Acceptée" tag.
 */
export const candidatStatusLabelsMap: Record<CandidatStatusOnMission, string> = {
  [CandidatStatusOnMission.ACCEPTED]: 'Acceptée',
  [CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH]: 'Contrat signé',
  [CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION]: 'En attente de validation établissement',
  [CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT]: 'Mission validée – en attente de paiement',
  [CandidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT]: 'Validation refusée par l\'établissement',
  [CandidatStatusOnMission.PAYMENT_DONE]: 'Paiement effectué',
  [CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY]: 'Annulée par l\'agence',
  [CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION]: 'Candidature reçue',
  [CandidatStatusOnMission.REJECTED]: 'Rejetée',
  [CandidatStatusOnMission.PENDING]: 'En attente',
  [CandidatStatusOnMission.NEUTRAL]: 'Neutre',
  [CandidatStatusOnMission.EXPIRED]: 'Expirée',
  [CandidatStatusOnMission.ARCHIVED]: 'Archivée',
  [CandidatStatusOnMission.RESERVED]: 'Réservée',
  [CandidatStatusOnMission.CANCELED_BY_ESTABLISHMENT]: 'Annulée par l\'établissement',
  [CandidatStatusOnMission.CANCELLATION_REQUEST_AFTER_SIGN_CONTRACT]: 'Demande d\'annulation',
  [CandidatStatusOnMission.CANCELLATION_ACCEPTED_AFTER_SIGNING]: 'Annulation acceptée',
  [CandidatStatusOnMission.REJECTED_BY_ESTABLISHMENT_AFTER_SIGNING]: 'Refusée après signature',
  [CandidatStatusOnMission.CANCELED_BY_CANDIDATE]: 'Annulée par le candidat',
  [CandidatStatusOnMission.VALIDATED]: 'Validée',
  [CandidatStatusOnMission.INVALIDATED]: 'Invalidée',
  [CandidatStatusOnMission.DRAFT]: 'Brouillon',
  [CandidatStatusOnMission.WAITING_FOR_VALIDATION]: 'En attente de validation',
  [CandidatStatusOnMission.CONTRACT_PENDING_VALIDATION]: 'Contrat en attente de validation',
};
